/**
 * applicationInstanceRelation模块接口列表
 */
import $http from '../utils/http' // 导入http中创建的axios实例

const applicationInstanceRelation = {
  // 增加applicationInstanceRelation关联表
  createApplicationInstanceRelation (params) {
    return $http.post(`${global.API_URL}/sme/applicationInstanceRelation/create`, params)
  },
  // 删除applicationInstanceRelation关联表
  deleteApplicationInstanceRelation (params) {
    return $http.post(`${global.API_URL}/sme/applicationInstanceRelation/deleteByApplicationIdAndInstanceId`, params)
  },
  // 根据应用ID和实例ID查询权重
  selectWeightByApplicationIdAndInstanceId (params) {
    return $http.post(`${global.API_URL}/sme/applicationInstanceRelation/selectWeightByApplicationIdAndInstanceId`, params)
  },
  // 编辑实例权重
  updateInstanceWeight (params) {
    return $http.post(`${global.API_URL}/sme/applicationInstanceRelation/updateInstanceWeight`, params)
  }
}

export default applicationInstanceRelation



// WEBPACK FOOTER //
// ./src/api/applicationInstanceRelation.js